import { render } from "./simple-layout.vue?vue&type=template&id=67f7e5ec"
const script = {}

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__